import { render, staticRenderFns } from "./topic.vue?vue&type=template&id=54796ca2&scoped=true"
import script from "./topic.vue?vue&type=script&lang=js"
export * from "./topic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54796ca2",
  null
  
)

export default component.exports